import React from 'react';

/** A headline metric tile. Ported verbatim from the prototype. */
export function StatCard({
  label,
  value,
  sub,
  accent
}: {
  label: string;
  value: React.ReactNode;
  sub?: string;
  accent?: string;
}): React.ReactElement {
  return (
    <div style={{background: '#fff', border: '1px solid #E2E8F0', borderRadius: 10, padding: '14px 18px', minWidth: 140}}>
      <div
        style={{
          fontSize: 28,
          fontWeight: 800,
          color: accent || '#0F172A',
          fontFamily: "'DM Mono', monospace",
          letterSpacing: '-0.02em'
        }}
      >
        {value}
      </div>
      <div style={{fontSize: 12, fontWeight: 600, color: '#334155', marginTop: 2}}>{label}</div>
      {sub && <div style={{fontSize: 11, color: '#94A3B8', marginTop: 1}}>{sub}</div>}
    </div>
  );
}
